var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"v-if":_vm.webviewHabilitada}},[_c('iframe',{directives:[{name:"show",rawName:"v-show",value:(_vm.show && _vm.url),expression:"show && url"}],attrs:{"id":"iframeMultiploId","widh":"100%","height":"100%","src":_vm.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }